/*
 * Opens links that leave the store in a new tab.
 *
 * Shopify's Navigation admin has no "open in new tab" option, and menu
 * markup is generated in several different snippets (header, drawer,
 * mega menu, footer). Handling it centrally here means it keeps working
 * when menus change or the theme is updated.
 */
(function () {
  function isExternal(anchor) {
    // Relative links resolve to the current host, so they are never external.
    if (anchor.hostname === window.location.hostname) return false;
    if (!/^https?:$/.test(anchor.protocol)) return false; // skip mailto:, tel:
    return true;
  }

  function mark(root) {
    var anchors = (root || document).querySelectorAll('a[href]');

    Array.prototype.forEach.call(anchors, function (anchor) {
      if (anchor.target === '_blank') return;
      if (!isExternal(anchor)) return;

      anchor.target = '_blank';
      // noopener closes a reverse-tabnabbing hole; noreferrer keeps the
      // referrer off third-party analytics.
      anchor.rel = (anchor.rel ? anchor.rel + ' ' : '') + 'noopener noreferrer';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mark(document);
    });
  } else {
    mark(document);
  }

  // The drawer and mega menu render their contents lazily, so re-scan
  // whenever nodes are added.
  if ('MutationObserver' in window) {
    var pending = false;

    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        mark(document);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
